module.exports = __webpack_public_path__ + "img/icon-lamp.135a194a.svg";